import theme from '@/theme';
import styled from '@emotion/styled';

export const Title = styled.h2`
    color: black;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 28px;
`;

export const OpaqueTitlePart = styled.span`
    color: ${theme.colors.secondary[500]};
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: -0.28px;
`;

export const SubTitle = styled.p`
    color: ${theme.colors.black[700]};
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
`;
